import { getDataList } from "../api/common";
import { 
    CREATEACTAS, CREATECLIENT, CREATEENTRY, CREATEITEM, CREATEMAG, CREATEOT, 
    CREATEREGISTER, CREATEROLE, CREATEUSER, FINANCIAL, TECNICHAL, 
    VIEWALLPROGRAMACION, VIEWCALENDAR, VIEWCLIENT, VIEWENTRY, VIEWOT, 
    VIEWPROGRAMACION, VIEWROLE, VIEWREQUISICIONES, VIEWPROVEEDORES,
    VIEW_PROPUESTAS, CREATE_PROPUESTAS, VIEW_DASHBOARD_PROPUESTAS, MANAGE_PLANTILLA_PROPUESTAS,
    REVISION_RELACIONES,
    GESTION_BOLSILLOS,
    GESTION_ENTREGAS,
    CONFIGURACION_CONTABLE,
    COMPROBANTES_CONTABLES,
    GESTION_ERRORES,
    DASHBOARD_FINANCIERO
} from "../components/Roles/ConstantRoute";
import { useAuth } from "../hooks/useAuth"; 
import React, { useState, useEffect } from 'react'

export const  RutasCrear=(permisos)=> {

        let Rutas=[]

        if(permisos.indexOf(CREATE_PROPUESTAS) !== -1)
        Rutas.push(
            {
            name:'Propuesta Comercial',
            route:'/propuestas/crear',
           })
    
        if(permisos.indexOf(CREATEOT) !== -1)
        Rutas.push(        
            {
            name:'Orden de Trabajo',
            route:'/crearOt',
           })
        if(permisos.indexOf(CREATEUSER) !== -1)
        Rutas.push(        
            {
            name:'Usuario',
            route:'/users',
            })
        if(permisos.indexOf(CREATECLIENT) !== -1)
        Rutas.push(        
            {
            name:'Cliente',
            route:'/clientes',
            })
        if(permisos.indexOf(CREATEENTRY) !== -1)
        Rutas.push(        
            {
            name:'Ingreso Equipos',
            route:'Ingresos/crear',
            })

        if(permisos.indexOf(CREATEITEM) !== -1)
        Rutas.push(        
            {
            name:'Items',
            route:'/items',
            })
        if(permisos.indexOf(CREATEMAG) !== -1)
        Rutas.push(        
            {
            name:'Magnitud',
            route:'/magnitud',
            })
        if(permisos.indexOf(CREATEROLE) !== -1)
        Rutas.push(        
            {
            name:'Roles',
            route:'/Roles',
            })
        //if(permisos.indexOf(CREATEREGISTER) !== -1)
        Rutas.push(        
            {
            name:'Registro',
            route:'/Registros',
            })
        Rutas.push(        
            {
            name:'Prestamo Equipos',
            route:'/prestamos/crear',
            })

  //console.log(Rutas)

  return (Rutas)
}

export const  RutasSideBar=(permisos)=> {
    
    const { userData } = useAuth(); // Obtener datos del usuario autenticado
    let Rutas=[]
    //console.log(permisos)
    
        if(permisos.indexOf(VIEWCALENDAR) !== -1)
        Rutas.push(        
            {
                name:'Calendario',
                icon:'bi-calendar3',
                route:'/calendario',
            })

        if(permisos.indexOf(VIEWPROGRAMACION) !== -1 || permisos.indexOf(VIEWALLPROGRAMACION) !== -1)
        Rutas.push(        
            {
                name:'Programaciones',
                icon:'bi bi-person-lines-fill',
                route:'ListaProgramaciones',
            })
        if(permisos.indexOf(VIEWOT) !== -1)
        Rutas.push(        
            {
                name:'Orden de Trabajo',
                icon:'bi-list-task',
                route:'/otlista/total',
            })
        if(permisos.indexOf(VIEWENTRY) !== -1)
        Rutas.push(        
            {
                name:'Ingresos Equipos',
                icon:'bi bi-building-up',
                route:'/Ingresos/listar',
            })
        if(permisos.indexOf(VIEWCLIENT) !== -1)
        Rutas.push(        
            {
                name:'Clientes',
                icon:'bi bi-people',
                route:'/clientes',
            })

        if(permisos.indexOf(VIEWROLE) !== -1)
        Rutas.push(        
            {
                name:'Roles',
                icon:'bi bi-person-rolodex',
                route:'/Roles',
            })
        if(permisos.indexOf(VIEW_PROPUESTAS) !== -1) {
            const comercialSubRoutes = [
                { name: 'Propuestas', route: '/propuestas' },
                { name: 'Plantilla', route: '/propuestas/plantilla' }
            ];
            if(permisos.indexOf(VIEW_DASHBOARD_PROPUESTAS) !== -1)
                comercialSubRoutes.push({ name: 'Dashboard', route: '/propuestas/dashboard' });
            Rutas.push({
                name:'Comercial',
                icon:'bi bi-briefcase',
                subRoute: comercialSubRoutes
            });
        }
        // Requisiciones - todos pueden ver por ahora
        Rutas.push(        
            {
                name:'Requisiciones',
                icon:'bi bi-clipboard-check',
                route:'/requisiciones',
            })
        // Proveedores - todos pueden ver por ahora  
        Rutas.push(        
            {
                name:'Proveedores',
                icon:'bi bi-truck',
                route:'/proveedores',
            })
        if(permisos.indexOf(TECNICHAL) !== -1)
        Rutas.push(        
            {
                name:'Gestión Técnica',
                icon:'bi bi-gear-wide-connected',
                subRoute:[
                    {   
                        name: 'Notificaciones',
                        route:'/NotficacionTecnica',
                    },
                    {   
                        name: 'Inventario',
                        route:'/Inventario',
                    },
                    {
                        name: 'Actividades',
                        route:'/Actividades',
                    },
                    {
                        name: 'Prestamos Equipos',
                        route:'/Prestamos',
                    },
                    {
                        name:'S/I Patrones',
                        route:'/SalidaEntradaPatrones'
                    }


                ] 
            })
        //if(permisos.indexOf(FINANCIAL) !== -1)
        // Submenu Finanzas — modulo 011 (Bolsa de Fondos). Items legacy

        const rolFin = userData?.role?.nombre;
        const verInforme = rolFin === 'Admin' || rolFin === 'Gerente' || rolFin === 'Contador';
        const subFinanzas = [
            // Vista administrativa global (informe gerencial)

            ...(permisos.indexOf(DASHBOARD_FINANCIERO) !== -1 ?  [{ name: 'Informe Financiero', route: '/Finanzas/informe' }] : []),
            // Módulo Financiero 011 (Bolsa de Fondos)
        
            { name: 'Mi Bolsillo', route: '/MiBolsa' },
            { name: 'Mis Relaciones',         route: '/MisRelaciones' },
            //colocar permiso REVISION_RELACIONES para revisar relaciones de otros usuarios, sin acceso a gestión de bolsillos
            ...(permisos.indexOf(REVISION_RELACIONES) !== -1 ? [{ name: 'Relaciones',             route: '/RevisionRelaciones' }] : []),
            ...(permisos.indexOf(GESTION_BOLSILLOS) !== -1 ? [{ name: 'Gestión Bolsillos',      route: '/GestionBolsillos' }] : []),
            ...(permisos.indexOf(GESTION_ENTREGAS) !== -1 ? [{ name: 'Gestión Entregas',       route: '/GestionEntregas' }] : []),  //este debe llevar un permiso específico para acceso a la gestión de entregas, que no necesariamente tienen que ver con la gestión de bolsillos
            ...(permisos.indexOf(GESTION_ERRORES) !== -1 ? [{ name: 'Errores Sincronización', route: '/ErroresSincronizacion' }] : []), //este debe llevar un permiso específico para acceso a la gestión de errores, que no necesariamente tienen que ver con la gestión de bolsillos
            ...(permisos.indexOf(CONFIGURACION_CONTABLE) !== -1 ? [{ name: 'Configuración Contable', route: '/ConfiguracionContable' }] : []), //este debe llevar un permiso específico para acceso a la configuración contable, que no necesariamente tienen que ver con la gestión de bolsillos
            ...(permisos.indexOf(COMPROBANTES_CONTABLES) !== -1 ? [{ name: 'Comprobantes Contables', route: '/ComprobantesContables' }] : []) // listado de comprobantes contables generados (Entrega, Traslado, Cierre) con su estado de sync
        ];
        Rutas.push({
            name: 'Finanzas',
            icon: 'bi bi-cash-stack',
            subRoute: subFinanzas
        });
        // Submenu Contabilidad — la entrada "Configuración" expone providers /
        // endpoints / mapeos contables. El backend restringe la API a Admin y
        // Contador via validateRole; aqui ocultamos el item para los demas
        // roles para no mostrar opciones que generarian 401.
        const rolUsuario = userData?.role?.nombre;
        const puedeConfigContable = rolUsuario === 'Admin' || rolUsuario === 'Contador';
        const subContabilidad = [];
        if (puedeConfigContable) {
            subContabilidad.push({
                name: 'Configuración',
                route: '/contabilidad/configuracion',
            });
        }
        subContabilidad.push({
            name: 'Cuentas Contables',
            route: '/ConexionContable/CC'
        });
        Rutas.push(
            {
                name: 'Contabilidad',
                icon: 'bi bi-calculator',
                subRoute: subContabilidad
            })
        Rutas.push(
            {
                name:'Registros',
                icon:'bi bi-journal-text',
                route:'/solicitudes',
            })


  console.log(Rutas)

  return (Rutas)
}